import { HealthMetrics } from '../../types/health';

const DEFAULT_METRICS: HealthMetrics = {
  heartRate: {
    current: 72,
    history: Array.from({ length: 24 }, () => Math.floor(Math.random() * 21) + 65)
  },
  strain: {
    current: 14.7,
    change: 2.3,
    dayHistory: Array.from({ length: 24 }, () => Math.floor(Math.random() * 10) + 5),
    optimal: {
      min: 12.0,
      max: 16.5
    }
  },
  recovery: 85, // Set to 85% for visualization
  sleep: {
    score: 92,
    hours: 7.5
  },
  readiness: 88,
  steps: {
    current: 8234,
    yesterday: 7500
  },
  calories: {
    current: 1850,
    yesterday: 2100
  },
  stress: {
    current: 65,
    yesterday: 72
  },
  weight: {
    current: 70.5,
    yesterday: 70.7
  },
  hrv: {
    current: 68,
    yesterday: 65
  }
};

export function simulateHealthMetrics(): HealthMetrics {
  return DEFAULT_METRICS;
}